import { render, staticRenderFns } from "./buyChangeCard2.vue?vue&type=template&id=05a5b9c4&scoped=true&"
import script from "./buyChangeCard2.vue?vue&type=script&lang=js&"
export * from "./buyChangeCard2.vue?vue&type=script&lang=js&"
import style0 from "./buyChangeCard2.vue?vue&type=style&index=0&id=05a5b9c4&lang=less&scoped=true&"
import style1 from "./buyChangeCard2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5b9c4",
  null
  
)

export default component.exports